const config = {
  platforms: {
    SA: {
      UI_URL: "https://sa.staging.reiformslive.com.au",
      API_URL: "https://sa-api.staging.reiformslive.com.au",
      declineEnabled: true,
    },
    FLSA: {
      UI_URL: "https://sa.formslive-staging.com.au",
      API_URL: "https://sa-api.formslive-staging.com.au",
      declineEnabled: true,
      checklistEnabled: true,

      theme: {
        icon: "fl-icon-inverted.png",
        logo: "fl-logo.png",
        "Theme-Color-Primary": "#4884ee",
        "Theme-Button-Primary": "#4884ee",
      },
    },
    AICSA: {
      UI_URL: "https://aic.formslive-staging.com.au",
      API_URL: "https://aic-api.formslive-staging.com.au",
      declineEnabled: true,
      checklistEnabled: true,

      theme: {
        icon: "aic-icon.png",
        logo: "aic-logo-white.png",
        "Theme-Color-Navbar": "#2d2f84",
        "Theme-Color-Primary": "#4fa59c",
        "Theme-Button-Primary": "#2d2f84",
      },
    },
    NSW: {
      UI_URL: "https://nsw.staging.reiformslive.com.au",
      API_URL: "https://nsw-api.staging.reiformslive.com.au",
      declineEnabled: true,
      checklistEnabled: true,
    },
    NT: {
      UI_URL: "https://nt.formslive-staging.com.au",
      API_URL: "https://nt-api.formslive-staging.com.au",
      declineEnabled: true,
    },
    TAS: {
      checklistEnabled: true,
      declineEnabled: true,
      UI_URL: "https://tas.formslive-staging.com.au",
      API_URL: "https://tas-api.formslive-staging.com.au",
    },
    ACT: {
      checklistEnabled: true,
      declineEnabled: true,
      UI_URL: "https://act.formslive-staging.com.au",
      API_URL: "https://act-api.formslive-staging.com.au",
    },
    NT: {
      checklistEnabled: true,
      declineEnabled: true,
      UI_URL: "https://nt.formslive-staging.com.au",
      API_URL: "https://nt-api.formslive-staging.com.au",
    },
    VIC: {
      declineEnabled: true,
      checklistEnabled: true,

      UI_URL: "https://vic.formslive-staging.com.au",
      API_URL: "https://vic-api.formslive-staging.com.au",
      theme: {
        icon: "fl-icon-inverted.png",
        logo: "fl-logo.png",
        "Theme-Color-Primary": "#4884ee",
        "Theme-Button-Primary": "#4884ee",
      },
    },
    VICNEW: {
      checklistEnabled: true,
      declineEnabled: true,
      UI_URL: "https://vic.formslive-staging.com.au",
      API_URL: "https://vic-api.formslive-staging.com.au",
      theme: {
        icon: "fl-icon-inverted.png",
        logo: "fl-logo.png",
        "Theme-Color-Primary": "#4884ee",
        "Theme-Button-Primary": "#4884ee",
      },
    },
    QLD: {
      declineEnabled: true,
      checklistEnabled: true,

      UI_URL: "https://qld.formslive-staging.com.au",
      API_URL: "https://qld-api.formslive-staging.com.au",
      theme: {
        icon: "fl-icon-inverted.png",
        logo: "fl-logo.png",
        "Theme-Color-Primary": "#4884ee",
        "Theme-Button-Primary": "#4884ee",
      },
    },
    WA: {
      declineEnabled: true,
      checklistEnabled: true,

      UI_URL: "https://wa.formslive-staging.com.au",
      API_URL: "https://wa-api.formslive-staging.com.au",
    },
  },
  livesign: {
    scriptId: "__livesign_widget",
    url: "https://sandbox.widget.verify.live-sign.com",
  },
};

export default config;
